import { Component, input } from '@angular/core';
import { VdoIconComponent } from 'ui-kit';

@Component({
  selector: 'vdo-map-marker-icon',
  imports: [VdoIconComponent],
  templateUrl: './vdo-map-marker-icon.component.html',
  styleUrl: './vdo-map-marker-icon.component.scss',
})
export class VdoMapMarkerIconComponent {
  color = input('#000000');
  icon = input('flag');
}
